import {
  getGridBooleanOperators,
  getGridNumericOperators,
  getGridStringOperators
} from "@mui/x-data-grid-pro";

import { getGridArrayOperators } from "../getGridArrayOperators";
import { getGridDateOperators } from "../getGridDateOperators/getGridDateOperators";
import { getGridOptionOperators } from "../getGridOptionOperators";

type ColumnType = "string" | "number" | "boolean" | "date" | "dateTime" | "singleSelect" | "array";

export const getFilterOperators = (dataType: ColumnType) => {
  switch (dataType) {
    case "string":
      return getGridStringOperators();
    case "number":
      return getGridNumericOperators();
    case "boolean":
      return getGridBooleanOperators();
    case "singleSelect":
      return getGridOptionOperators();
    case "array":
      return getGridArrayOperators();
    case "date":
    case "dateTime":
      return getGridDateOperators();
  }
};
